import { useEffect } from "react";
import { Session } from "@/session";
import { LOGIN_URL } from "@/services/ServiceConstants";
import { logoutPHP } from "@/services/sessionServices";
import { IS_LOCALHOST } from "@/config/Constants";
import { FullPageLoadingLayout } from "@/components/Layouts";

/**
 * Logout component.
 * this is rendered when the route is logout
 *
 * Session.start and Session.onChange is removed from this file as
 * there are no real usage of it
 *
 * the session destroy is moved to a useEffect hook
 * i.e. the session clear will run only when this component is mounted.
 *
 * this useEffect will only run once at the initial mount, and
 * does not require any trigger/deps to run.
 */
export default function Logout() {
  useEffect(() => {
    logoutPHP().then(() => {
      Session.destroy("login"); // destroy react session
      localStorage.removeItem("login");
      sessionStorage.setItem("noSessionRefer", "true");
      localStorage.setItem("hasSessionProvider", false); // for the sake of react_app

      // if (IS_LOCALHOST)
        window.location.replace(LOGIN_URL); //destroy session in php
      // else window.location.replace(LOGIN_URL.replace("v2", "revamp"));
    });
    // eslint-disable-next-line
  }, []);

  return <FullPageLoadingLayout />;
}
